import { timer } from 'rxjs';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Servidor } from '../_classes/servidor';
import { ServidorSrh2 } from '../_classes/servidor-srh2';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from '../_classes/util';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-dados-funcionais',
  templateUrl: './dados-funcionais.component.html',
  styleUrls: ['./dados-funcionais.component.scss'],
})
export class DadosFuncionaisComponent implements OnInit {
  private readonly recurso: string = 'dados-funcionais';
  carregando = false;

  servidor$: Observable<Servidor>;
  servidor: Servidor;

  servidorSrh2$: Observable<ServidorSrh2>;
  servidorSrh2: ServidorSrh2;

  erros$ = new Subject<boolean>();

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private env: EnvService
  ) {
    this.carregando = true;
  }

  ngOnInit() {
    this.atualizar();
  }

  executarAoCarregarDatasource(x: ServidorSrh2) {
    this.servidorSrh2 = new ServidorSrh2(x);
    this.servidor = new Servidor(this.env.servidor);
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    if (this.env.servidor?.servidorSrh2) {
      this.executarAoCarregarDatasource(this.env.servidor.servidorSrh2);
    }
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
